// extracted by mini-css-extract-plugin
export var container = "privateTours-module--container--PHihC";
export var info = "privateTours-module--info--RRwp_";